import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    currentData: null,
    measurementGroups: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    dataStart: (state) => {
      state.isFetching = true;
    },
    dataSuccess: (state, action) => {
      state.isFetching = false;
      state.currentData = action.payload;
    },
    dataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    measurementGroupsSuccess: (state, action) =>{
      state.measurementGroups = action.payload;
    },
    logoutMeasurementGroupsData: (state) => {
      state.currentData = null;
      state.measurementGroups = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const { dataStart, dataSuccess, dataFailure, measurementGroupsSuccess, logoutMeasurementGroupsData } =
  dataSlice.actions;
export default dataSlice.reducer;
